import React from "react";
import Modal from "react-modal";
import { useStateValue } from "../../StateProvider";
import { getDefaultValue } from "../../utils";
import ImageCrop from "../shared/ImageCrop";

export default function ModalCropImage({ file,onSuccess,onOutput,isOpen = false, setIsOpen ,...props}) {

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    const tr = translations.find((x) => x.key === str);
    return tr ? getDefaultValue(tr) : str;
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  
  return (
    <Modal
      closeTimeoutMS={500}
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="Modal"
      overlayClassName="Overlay"
    >
      <div className="modal-content bg-upload-material">
        <div className="modal-header modal-header--polished no-border pb-0">
          <h2 className="modal-title-polished lan-text-right">{translate("Photo")}</h2>
          <button
            type="button"
            className="close modal-close-ghost"
            onClick={closeModal}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="modal-body lan-text-right pt-3">
          <ImageCrop file={file} onSuccess={onSuccess} onOutput={onOutput} />
        </div>

      </div>
    </Modal>
  );
}
